import { Env } from '@app/types/env';
import { NgxLoggerLevel } from 'ngx-logger';

export const environment: Env = {
  appVersion: `${require('../../package.json').version}`,
  production: true,
  apiBaseUrl: '',
  apiBaseUrl_local: 'http://localhost:7003/wsguiescliniques',
  apiBaseUrl_dev: 'http://localhost:7003/wsguiescliniques',
  apiBaseUrl_pre: 'https://preproduccio.guiescliniques.sem.gencat.cat:443/wsguiescliniques',
  apiBaseUrl_pro: 'https://guiescliniques.sem.gencat.cat:443/wsguiescliniques',
  apiBaseUrlExpress: 'http://localhost:3000',
  logLevel: NgxLoggerLevel.ERROR,
  assetsPath: ''
};
